import PropTypes from "prop-types";

import styles from "./styles.module.css";

const ProjectFeatures = ({ features }) => {
  if (!features?.length) return null;

  return (
    <section className={styles.wrapper}>
      <b className={styles.title}>Proje Özellikleri</b>

      <ul className={styles.items}>
        {features.map((feature, index) => (
          <li key={`feature-${index}`} className={styles.featureItem}>
            {feature}
          </li>
        ))}
      </ul>
    </section>
  );
};

ProjectFeatures.propTypes = {
  features: PropTypes.array,
};

export default ProjectFeatures;
